import { render, staticRenderFns } from "./CoursesMap.vue?vue&type=template&id=4edd2032&scoped=true"
import script from "./CoursesMap.vue?vue&type=script&lang=js"
export * from "./CoursesMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edd2032",
  null
  
)

export default component.exports